export default __webpack_public_path__ + "static/media/dictionary1.1ea222b7.png";